<canvas
  baseChart
  [data]="chartData"
  [options]="chartOptions"
  [plugins]="chartPlugins"
  [legend]="false"
  type="scatter"
  *ngIf="chartData"
  (chartClick)="onChartClick($event)"
>
</canvas>
